import React from 'react';

let ReCaptchaV3;
if (process.env.WEB !== 'true') {
  ReCaptchaV3 = require('@haskkor/react-native-recaptchav3').default;
}

export function Captcha({ setToken, reCaptchaRef, action }) {
  if (ReCaptchaV3 == null) return null;
  return (
    <ReCaptchaV3
      ref={reCaptchaRef}
      action={action}
      captchaDomain={'https://relevant.community'}
      siteKey={process.env.RECAPTCHA_KEY}
      onReceiveToken={(token) => setToken(token)}
    />
  );
}
